import * as React from "react";
import Modal from "../../ui/modal/Modal";
import SingleFileSelector from "../../file/SingleFileSelector";
import Toast from "../../helper/Toast";
import {option} from "ts-option";
import {api} from "../../../api/api";
import {ImportResult} from "../../../model/importResult/ImportResult";
import {notifyBugsnag} from "../../../utils/Utils";

interface Props {
	onSuccess: () => void;
	onCancel: () => void;
}

interface IState {
	filesUploading: boolean;
	errors: string[];
}

export default class UploadHistoricalJobsModal extends React.Component<Props, IState> {

	constructor(props: Props) {
		super(props);
		this.state = {filesUploading: false, errors: []};
		this.uploadFile = this.uploadFile.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onCancel} title={"Upload historical jobs"}>
				<SingleFileSelector onUpload={this.uploadFile}
									onCancel={this.props.onCancel}
									errors={option(this.state.errors)}
									filesUploading={this.state.filesUploading}
									accept={".xlsx"}/>
			</Modal>
		);
	}

	uploadFile(file: File) {
		if (file) {
			this.setState({filesUploading: true}, () => {
				api.instance.historicalJobImportApi.startImport(file).then(() => {
					Toast.success("Historical jobs import started.", "Historical jobs upload");
					this.setState({filesUploading: false});
					this.props.onSuccess();
				}).catch((error: any) => {
					const errors = error.response && error.response.data
						? ImportResult.fromJson(error.response.data).error
						: [];
					if (!error.response) {
						notifyBugsnag(error);
					}
					this.setState({errors, filesUploading: false});
					Toast.error("Cannot upload historical jobs.", "Historical jobs upload");
				});
			});
		}
	}
}
